/**
 * guide/donation tier chip swap island.
 *
 * Mount: `<div data-mount="donation-tiers">` 안에
 *   - chip 3 개 — `<button data-tier-chip data-amount="..." data-url="..." data-target="qr-...">`
 *   - QR 영역 — `<a data-tier-link href="...">` 안 `<span data-tier-qr id="qr-...">{{ svg }}</span>` × 3
 *
 * 흐름:
 *   - chip 클릭 → 클릭한 chip aria-pressed=true / 나머지 false
 *                → data-target 매치하는 QR span 만 visible / 나머지 hidden
 *                → anchor href 를 chip 의 data-url 로 swap
 *   - DOM only, fetch 0, JS 0 의존.
 */

function applyTier(root: HTMLElement, chip: HTMLButtonElement): void {
  const chips = root.querySelectorAll<HTMLButtonElement>("[data-tier-chip]");
  for (const c of chips) c.setAttribute("aria-pressed", c === chip ? "true" : "false");

  const targetId = chip.dataset.target;
  if (!targetId) return;
  const qrs = root.querySelectorAll<HTMLElement>("[data-tier-qr]");
  for (const q of qrs) q.hidden = q.id !== targetId;

  const url = chip.dataset.url;
  const link = root.querySelector<HTMLAnchorElement>("[data-tier-link]");
  if (link && url) link.href = url;
}

export function mountDonationTiers(root: HTMLElement): void {
  const chips = root.querySelectorAll<HTMLButtonElement>("[data-tier-chip]");
  for (const chip of chips) {
    chip.addEventListener("click", () => applyTier(root, chip));
  }
}
